var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from 'react';
import { loadStripe, } from '@stripe/stripe-js';
import { Elements, useStripe, useElements, CardNumberElement, CardCvcElement, CardExpiryElement, } from '@stripe/react-stripe-js';
import { Colors } from '@lean-body/components/styles';
import { css, StyleSheet } from 'aphrodite';
import { CCBrandIcon, CircleCheckIcon } from '../atoms';
import { useRefHooks } from '@lean-body/src/util';
import { CCFormSubmitType } from './cc_form';
const { useState, useEffect } = React;
const CheckoutForm = (props) => {
    const { afterSubmit, openSection, hideSectionTitle, hiddenInputRef, hiddenInputElement, createSetupIntent, onSubmitFirstPlan, onSubmitSecondaryPlan, } = props;
    const stripe = useStripe();
    const elements = useElements();
    const [cardNumber, changeCardNumber] = useState(false);
    const [cardExpire, changeCardExpire] = useState(false);
    const [cardCvc, changeCardCvc] = useState(false);
    const { ref, element } = useRefHooks();
    useEffect(() => {
        props.changeFilledAllForm(cardNumber && cardExpire && cardCvc);
    }, [cardNumber, cardExpire, cardCvc]);
    useEffect(() => {
        // クレカ入力のformを最小化したときに、入力中の値に自動でscrollされてしまうので、されないように調整
        const scrollToTop = () => element.scrollTo(0, 0);
        element === null || element === void 0 ? void 0 : element.addEventListener('scroll', scrollToTop);
        return () => element === null || element === void 0 ? void 0 : element.removeEventListener('scroll', scrollToTop);
    }, [element]);
    const options = (placeholder) => {
        return {
            placeholder: placeholder,
            style: {
                base: {
                    color: Colors.Black,
                    fontSize: '16px',
                    lineHeight: '20px',
                    '::placeholder': {
                        color: Colors.GrayDarkest,
                    },
                },
                invalid: {
                    color: '#9e2146',
                },
            },
        };
    };
    const handleSubmit = (event) => __awaiter(void 0, void 0, void 0, function* () {
        event.preventDefault();
        const validated = props.beforeSubmit(true);
        if (!validated)
            return;
        const setupIntent = yield createSetupIntent();
        const result = yield stripe.confirmCardSetup(setupIntent.clientSecret, {
            payment_method: { card: elements.getElement(CardNumberElement) },
        });
        if (result.error) {
            props.showErrorFromStripeInput([result.error.message]);
            return;
        }
        // errorがある場合、tokenは作成されない
        switch (hiddenInputElement.value) {
            case CCFormSubmitType.firstPlan:
                yield onSubmitFirstPlan(result.setupIntent.payment_method);
                break;
            case CCFormSubmitType.secondaryPlan:
                yield onSubmitSecondaryPlan(result.setupIntent.payment_method);
                break;
        }
        afterSubmit();
    });
    const onChangeCardNumber = (event) => {
        changeCardNumber(event.complete);
        if (event.complete) {
            elements.getElement(CardExpiryElement).focus();
        }
    };
    const onChangeCardExpire = (event) => {
        changeCardExpire(event.complete);
        if (event.complete) {
            elements.getElement(CardCvcElement).focus();
        }
    };
    const onChangeCardCvc = (event) => {
        changeCardCvc(event.complete);
    };
    return (React.createElement("form", { onSubmit: handleSubmit, className: css(styles.form) },
        React.createElement("input", { type: "hidden", ref: hiddenInputRef }),
        React.createElement("div", { className: css(styles.section, openSection && styles.sectionOpened), ref: ref },
            hideSectionTitle && (React.createElement("div", { className: css(styles.sectionTitle), onClick: props.onClickSection },
                openSection ? (React.createElement(CircleCheckIcon, { classObject: styles.checkIcon, filled: true, color: Colors.Black })) : (React.createElement("div", { className: css(styles.checkIcon, styles.notChecked) })),
                "\u30AF\u30EC\u30B8\u30C3\u30C8\u30AB\u30FC\u30C9\u3067\u304A\u652F\u6255\u3044")),
            React.createElement("div", { className: css(styles.title) }, "\u30AB\u30FC\u30C9\u60C5\u5831\u3092\u5165\u529B"),
            React.createElement(CCBrandIcon, { classObject: styles.brandIcons }),
            React.createElement("div", { className: css(styles.label) }, "\u30AB\u30FC\u30C9\u756A\u53F7"),
            React.createElement("div", { className: css(styles.input) },
                React.createElement(CardNumberElement, { options: options('半角数字'), onChange: onChangeCardNumber })),
            React.createElement("div", { className: css(styles.label) }, "\u6709\u52B9\u671F\u9650"),
            React.createElement("div", { className: css(styles.input) },
                React.createElement(CardExpiryElement, { options: options('月 / 年'), onChange: onChangeCardExpire })),
            React.createElement("div", { className: css(styles.label) }, "\u30BB\u30AD\u30E5\u30EA\u30C6\u30A3\u30FC\u30B3\u30FC\u30C9(\u30AB\u30FC\u30C9\u88CF\u306E\u6570\u5B57)"),
            React.createElement("div", { className: css(styles.input) },
                React.createElement(CardCvcElement, { options: options('半角数字(3桁または4桁)'), onChange: onChangeCardCvc })),
            React.createElement("div", { className: css(styles.noticeMsg) }, "\u203BAMEX\u306F4\u6841")),
        stripe && props.children));
};
export const StripeCardForm = (props) => {
    const [stripePromise] = React.useState(() => loadStripe(props.stripeAPIKey));
    return (React.createElement(Elements, { stripe: stripePromise },
        React.createElement(CheckoutForm, { afterSubmit: props.afterSubmit, showErrorFromStripeInput: props.showErrorFromStripeInput, beforeSubmit: props.beforeSubmit, changeFilledAllForm: props.changeFilledAllForm, openSection: props.openSection, onClickSection: props.onClickSection, hideSectionTitle: props.hideSectionTitle, hiddenInputRef: props.hiddenInputRef, hiddenInputElement: props.hiddenInputElement, createSetupIntent: props.createSetupIntent, onSubmitFirstPlan: props.onSubmitFirstPlan, onSubmitSecondaryPlan: props.onSubmitSecondaryPlan }, props.children)));
};
const styles = StyleSheet.create({
    form: {
        fontSize: 14,
        fontWeight: 'bold',
        textAlign: 'left',
    },
    section: {
        padding: '16px 14px',
        border: `1px solid ${Colors.PrimaryDark}`,
        borderRadius: 4,
        maxHeight: 52,
        transition: 'all .2s',
        overflow: 'hidden',
    },
    sectionOpened: {
        maxHeight: 600,
    },
    sectionTitle: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: 16,
    },
    notChecked: {
        backgroundColor: Colors.Gray,
        borderRadius: 100,
    },
    checkIcon: {
        margin: '0 8px 0 4px',
        width: 16,
        height: 16,
    },
    brandIcons: {
        margin: '14px 0',
    },
    title: {
        textAlign: 'center',
    },
    label: {
        margin: '14px 0 8px',
    },
    input: {
        position: 'relative',
        width: '100%',
        border: `1px solid ${Colors.Gray}`,
        '-webkit-appearance': 'none',
        borderRadius: 4,
        height: 50,
        padding: '15px 12px',
    },
    noticeMsg: {
        marginTop: 8,
        fontWeight: 'normal',
        color: Colors.GrayDarkest,
    },
});
